import { ErrorDisplay } from '@/components/types/ErrorDisplay'
import { ErrorTypes } from '../types'
import { mapErrorCategoryToUserMsg } from './mapErrorCategoryToUserMsg'

// Note the lang param: internationalization has not been implemented yet, keep for future-proofing.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const mapErrorToDisplayError = (e: ErrorTypes, lang: string): ErrorDisplay => {
  const { message, action } = mapErrorCategoryToUserMsg(e.category, lang)

  return {
    message,
    action,
    excerpt: e.excerpt,
    error: e,
  }
}
